<template>
  <v-row
    no-gutters
    class="chat-greeting-row"
  >
    <v-col
      cols="12"
      sm="12"
      md="12"
      class="chat-greeting-col"
    >
      <div class="chat-greeting">
        <p
          v-if="greetingTitle"
          class="chat-greeting-title"
        >
          Nice to see you, {{ greetingTitle }}.
        </p>

        <div
          v-if="loading"
          class="loading-container"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="20"
            width="2"
          />
        </div>

        <p
          v-else-if="greetingText"
          class="chat-greeting-content"
        >
          {{ greetingText }}
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ChatGreeting',

  dataStore: {
    assistantStore: 'AssistantStore'
  },

  computed: {
    greeting () {
      return this.assistantStore.Greeting?.Data
    },

    greetingText () {
      return (this.greeting && this.greeting.content) || ''
    },

    greetingTitle () {
      return this.user?.firstName || ''
    },

    loading () {
      return Boolean(this.assistantStore.Greeting?.Loading)
    }
  }
}
</script>

<style scoped>
.chat-greeting-row {
  width: 100%;
  margin: 0;
}

.chat-greeting-col {
  min-width: 0;
  padding: 0;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
}

.chat-greeting {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0 12px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.chat-greeting-title {
  color: #041f30;
  font-size: 17px;
  font-family: 'Aeonik';
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  overflow-wrap: anywhere;
  padding-top: 45px;
}

.chat-greeting-content {
  margin: 0;
  color: #11224e;
  font-family: 'Aeonik';
  font-size: 17px;
  font-weight: 700;
  line-height: 21px;
  text-align: center;
  overflow-wrap: anywhere;
  max-width: 100%;
  padding-bottom: 20px;
}

@media (max-width: 620px) {
  .chat-greeting-title {
    font-size: 18px;
  }
}
</style>
